
export function getSiteTypes() {
    return [
        { name: 'SEO/AEO', code: 'seo' },
        { name: 'PPC/Google Ads/Bing', code: 'ppc' },
        { name: 'Social Traffic', code: 'social' },
        { name: 'Email Traffic  ', code: 'email' },
        { name: 'App Traffic', code: 'app' },
        { name: 'Retargeting', code: 'retargeting' },
        { name: 'Display (programmatic)', code: 'display' },
        { name: 'Sms Traffic', code: 'sms' },
        { name: 'Content Creators & Influencers', code: 'contentcreators' }
    ];
}
